"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _Purchases_purchasesAPI;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Purchases = void 0;
const event_bus_1 = require("@completeanatomy/event-bus");
const http_1 = require("@completeanatomy/http");
const licenses_1 = require("@completeanatomy/licenses");
require("reflect-metadata");
const typedi_1 = require("typedi");
const api_1 = require("./api");
let Purchases = class Purchases {
    constructor(http, eventBus) {
        this.http = http;
        this.eventBus = eventBus;
        _Purchases_purchasesAPI.set(this, void 0);
        __classPrivateFieldSet(this, _Purchases_purchasesAPI, new api_1.PurchasesAPI(this.http), "f");
    }
    redeemCode(code) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        return __awaiter(this, void 0, void 0, function* () {
            /**
             * Redeem code on the backend
             */
            const response = yield __classPrivateFieldGet(this, _Purchases_purchasesAPI, "f").redeemCode(code);
            this.eventBus.emit(event_bus_1.AuthEvent.NeedUpdateUserData);
            /**
             * Updates content purchases in SyncManager
             */
            if (response.content) {
                // @ts-ignore -- hack for legacy code
                (_c = (_b = (_a = window.Manager) === null || _a === void 0 ? void 0 : _a.SyncManager) === null || _b === void 0 ? void 0 : _b.setContentPurchases) === null || _c === void 0 ? void 0 : _c.call(_b, response.content);
            }
            /**
             * Show success redeem popover if the redeemed code is the license code
             */
            if (!response.organization &&
                response.redeemed &&
                response.redeemed.length > 0) {
                // @ts-ignore -- hack for legacy code
                const popupManager = (_d = window.Manager) === null || _d === void 0 ? void 0 : _d.PopupManager;
                // @ts-ignore -- hack for legacy code
                const redeemSuccessPopupType = (_e = window === null || window === void 0 ? void 0 : window.POPUP_TYPES) === null || _e === void 0 ? void 0 : _e.REDEEM_SUCCESS;
                const bundleName = response.redeemed[0];
                const licenseType = (0, licenses_1.getLicenseTypeByBundleName)(bundleName);
                const licenseName = (0, licenses_1.stringsForLicenseType)(licenseType).name;
                (_f = popupManager === null || popupManager === void 0 ? void 0 : popupManager.show) === null || _f === void 0 ? void 0 : _f.call(popupManager, redeemSuccessPopupType, { name: licenseName });
            }
            // @ts-ignore -- hack to fire event for legacy code
            (_j = (_h = (_g = window.Utils) === null || _g === void 0 ? void 0 : _g.EventEmitter) === null || _h === void 0 ? void 0 : _h.fire) === null || _j === void 0 ? void 0 : _j.call(_h, 'RedeemedWithResult', response);
        });
    }
};
exports.Purchases = Purchases;
_Purchases_purchasesAPI = new WeakMap();
/**
 * Name of exported module property
 */
Purchases.exportName = 'purchases';
exports.Purchases = Purchases = __decorate([
    (0, typedi_1.Service)(),
    __metadata("design:paramtypes", [http_1.HTTP,
        event_bus_1.EventBus])
], Purchases);
